import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export const prepareDetailPropertyPosition = (
  data: IPropertyDetailsResponse
): string | null => {
  const positionImprovement = data?.improvements_list?.find(
    improvement => improvement.name === "Ubicaci&oacute;n"
  );

  return positionImprovement?.value || null;
};
